/**
 * Search Service - API calls for global search
 */

const API_URL = process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== '' ? process.env.REACT_APP_API_URL : '/api';

export interface SearchResultItem {
  type: string;
  id: number;
  name: string;
  category: 'map' | 'topology' | 'statistics' | 'documentation';
  icon: string;
  description: string;
  // Optional fields
  pole_type?: string;
  coordinates?: {
    lat: number | null;
    lng: number | null;
  };
  start?: string;
  end?: string;
  fiber_count?: number;
}

export interface SearchResult {
  query: string;
  results: {
    map: SearchResultItem[];
    topology: SearchResultItem[];
    statistics: SearchResultItem[];
    documentation: SearchResultItem[];
  };
  total: number;
}

/**
 * Search across all entities in a project
 */
export async function searchAll(query: string, projectId: number, limit: number = 50): Promise<SearchResult> {
  const token = localStorage.getItem('token');
  
  const response = await fetch(
    `${API_URL}/search?q=${encodeURIComponent(query)}&project_id=${projectId}&limit=${limit}`,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Search failed: ${response.statusText}`);
  }

  return response.json();
}


// ── Hľadanie zákazníka naprieč projektami ────────────────────────────────────
// Technik v teréne nevie, v ktorom projekte zákazník je, preto sa toto hľadanie
// na rozdiel od searchAll() neviaže na jeden projekt. Rozsah obmedzuje server
// podľa práv používateľa.

export interface NajdenyStlpik {
  id: number | null;
  nazov: string | null;
  typ: string | null;
  latitude: number | null;
  longitude: number | null;
}

export interface NajdenySplitter {
  index: number | null;
  typ: string | null;
  vstupny_zdroj: string;
  vstupny_kabel_id: number | null;
  vstupny_kabel: string | null;
  vstupne_vlakno: number | null;
  vstupny_buffer: number | null;
}

export interface NajdenyZakaznik {
  /** kazeta = zapísal technik do kazety, zoznam = tabuľka zákazníkov, onu = zariadenie */
  zdroj: 'kazeta' | 'zoznam' | 'onu';
  meno: string;
  telefon: string | null;
  adresa: string | null;
  email?: string | null;
  cislo_zakaznika?: string | null;
  stav?: string | null;
  projekt: { id: number; nazov: string };
  stlpik: NajdenyStlpik;
  kazeta: { pole_id: number; nazov: string | null; virtualna: boolean } | null;
  splitter: NajdenySplitter | null;
  vystup: number | null;
  osadil?: string | null;
  kedy?: string | null;
  poznamka?: string | null;
  /** pri zdroji „zoznam": či to isté meno figuruje aj v niektorej kazete */
  aj_v_kazete?: boolean;
  onu?: {
    id: number;
    nazov: string | null;
    seriove_cislo: string | null;
    mac: string | null;
    model: string | null;
    stav: string | null;
    farba_vlakna: string | null;
  };
}

export interface VysledokHladaniaZakaznikov {
  query: string;
  total: number;
  results: NajdenyZakaznik[];
  orezane?: boolean;
}

export async function searchCustomers(
  query: string,
  limit: number = 50,
): Promise<VysledokHladaniaZakaznikov> {
  const token = localStorage.getItem('token');
  const response = await fetch(
    `${API_URL}/search/customers?q=${encodeURIComponent(query)}&limit=${limit}`,
    { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } },
  );
  if (!response.ok) {
    let detail = response.statusText;
    try {
      detail = (await response.json())?.detail || detail;
    } catch {
      /* odpoveď nemusí byť JSON */
    }
    throw new Error(detail);
  }
  return response.json();
}
